import { mergeColumnVisibilityWithAuditDefaults } from './tabulatorAuditColumns';

/** Kanonické poradie stĺpcov (field-based layout merge) pre V6c embedded tabuľky. */
export const EMBEDDED_CANONICAL_FIELD_ORDERS = Object.freeze({
  MaintenanceCompanyContactAdd: Object.freeze([
    'rowSelection',
    'editor',
    'id',
    'name',
    'tel_number',
    'email',
    'description',
    'lecturer.name',
    'created_at',
    'updated_at',
  ]),
  MaintenanceCompanyCertificateAdd: Object.freeze([
    'rowSelection',
    'editor',
    'id',
    'name',
    'deactivation_date',
    'certificate_status',
    'responsible.name',
    'required_attachment',
    'description',
    'created_at',
    'updated_at',
  ]),
  MaintenanceCompanyCertRecordDetail: Object.freeze([
    'rowSelection',
    'id',
    'name',
    'description',
    'custom_start_of_validity',
    'custom_end_of_validity',
    'cert_description',
    'certificate_status',
    'responsible.name',
    'state',
    'protocol',
    'created_at',
    'updated_at',
  ]),
});

const DEFAULT_VISIBILITY_BY_PAGE = Object.freeze({
  MaintenanceCompanyContactAdd: Object.freeze({
    id: true,
    name: true,
    tel_number: true,
    email: true,
    description: true,
    'lecturer.name': true,
    created_at: true,
    updated_at: true,
  }),
  MaintenanceCompanyCertificateAdd: Object.freeze({
    id: true,
    name: true,
    deactivation_date: true,
    certificate_status: true,
    'responsible.name': true,
    required_attachment: true,
    description: true,
    created_at: true,
    updated_at: true,
  }),
  MaintenanceCompanyCertRecordDetail: Object.freeze({
    id: true,
    name: true,
    description: true,
    custom_start_of_validity: true,
    custom_end_of_validity: true,
    cert_description: true,
    certificate_status: true,
    'responsible.name': true,
    state: true,
    protocol: true,
    created_at: true,
    updated_at: true,
  }),
});

export function getEmbeddedCanonicalFieldOrder(maskPage) {
  return EMBEDDED_CANONICAL_FIELD_ORDERS[maskPage] ?? null;
}

export function getEmbeddedDefaultColumnVisibility(maskPage) {
  const base = DEFAULT_VISIBILITY_BY_PAGE[maskPage];
  return base ? { ...base } : {};
}

export function mergeEmbeddedColumnVisibilityFromSaved(maskPage, saved) {
  const defaults = DEFAULT_VISIBILITY_BY_PAGE[maskPage];
  if (!defaults) return saved && typeof saved === 'object' ? { ...saved } : {};
  return mergeColumnVisibilityWithAuditDefaults(defaults, saved);
}

export function applyEmbeddedDataColumnVisibility(table, maskPage, visibility) {
  if (!table) return;
  const defaults = DEFAULT_VISIBILITY_BY_PAGE[maskPage];
  if (!defaults) return;
  for (const field of Object.keys(defaults)) {
    if (visibility[field] === false) table.hideColumn?.(field);
    else table.showColumn?.(field);
  }
}
